import { render, staticRenderFns } from "./EmpresaParceiraEditar.vue?vue&type=template&id=ef07f50c"
import script from "./EmpresaParceiraEditar.vue?vue&type=script&lang=js"
export * from "./EmpresaParceiraEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports